// ----------------------------------------------------------------------

export const fullName = [
  'John Doe',
  'Jane Doe',
  'Smith Davis',
  'Anna Marie',
  'Kenedy Benedict',
  'Larry Tracy',
  'Trevor Debonds'
];

export const firstName = [
  'John',
  'Jane',
  'Smith',
  'Kenedy',
  'Trevor'
];

export const lastName = [
  'Doe',
  'Doe',
  'Davis',
  'Marie',
  'Benedict',
  'Tracy',
  'Debonds'
];
